<div class="page-header" *ngIf="!isModal">
  <div class="page-title">
    <h3>
      {{ !createMode ? ('ZONE' | translate) + ' / ' + zone.name : ('NEW_ZONE' | translate) }}
    </h3>
  </div>
  <div class="pull-right">
    <div class="form-actions no-wrap">
      <app-item-detail-form-actions
        [createMode]="createMode"
        [disableSaveItem]="form.invalid || (!loadingLocations && locations.length === 0)"
        [sendingForm]="sendingForm"
        [viewMode]="viewMode"
        (canceled)="onCanceled()"
        (edited)="onEditedZone()"
        (saved)="onSavedZone()"
      >
      </app-item-detail-form-actions>
    </div>
  </div>
</div>

<div class="alert alert-danger fade in" *ngIf="!loadingLocations && locations.length === 0">
  <h4>{{ 'PLEASE_CORRECT_ERRORS' | translate }}</h4>
  <button type="button" class="btn btn-inverse" (click)="openLocationsModal()">
    <i class="fa fa-plus"></i> {{ 'ADD_LOCATION' | translate }}
  </button>
</div>

<form [formGroup]="form" class="form-horizontal" autocomplete="off" novalidate>
  <app-translation-options
    [defaultLanguage]="defaultLanguage"
    [additionalLanguages]="additionalLanguages"
    (openedTranslation)="onOpenedTranslation($event)"
    *ngIf="!createMode && additionalLanguages.length > 0"
  ></app-translation-options>

  <div class="widget">
    <div class="widget-header">
      <h4>{{ 'ZONE_DETAILS' | translate }}</h4>
    </div>
    <div class="widget-content">
      <!-- Name -->
      <div class="form-group">
        <label class="col-md-3 control-label">
          {{ 'NAME' | translate }}
          <span class="required" [hidden]="viewMode">*</span>
        </label>
        <div class="col-md-9">
          <div *ngIf="viewMode" class="form-label">
            {{ zone.name }}
          </div>
          <div *ngIf="!viewMode">
            <input type="text" class="form-control" formControlName="name" maxlength="255" />
            <app-form-errors
              [control]="form.controls['name']"
              [formSubmited]="formSubmited"
            ></app-form-errors>
            <!-- [messages]="errorMessages['name']" -->
            <app-form-server-errors [error]="serverErrors['name']"></app-form-server-errors>
          </div>
        </div>
      </div>

      <!-- Description -->
      <div class="form-group">
        <label class="col-md-3 control-label">{{ 'DESCRIPTION' | translate }}</label>
        <div class="col-md-9">
          <div [hidden]="!viewMode" class="form-label">
            {{ zone.description || '-' }}
          </div>
          <div [hidden]="viewMode">
            <textarea class="form-control" formControlName="description" rows="3"></textarea>
          </div>
        </div>
      </div>
    </div>
    <!-- /.widget-content -->
  </div>
  <!-- /.widget -->

  <br />
  <div class="widget">
    <div class="widget-header">
      <h4>{{ 'LOCATION_DETAILS' | translate }}</h4>

      <div class="toolbar" *ngIf="!viewMode">
        <div class="btn-group">
          <span class="dropdown-toggle btn btn-xs" data-toggle="dropdown">
            <i class="fa fa-cog"></i>
          </span>
          <ul class="dropdown-menu pull-right">
            <li>
              <a href (click)="openLocationsModal()">
                <i class="fa fa-map-marker fa-sized"></i> {{ 'EDIT_LOCATIONS' | translate }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="widget-content">
      <!-- Locations -->
      <div class="form-group">
        <label class="col-md-3 control-label">
          <span class="required" [hidden]="viewMode">*</span> {{ 'LOCATIONS' | translate }}
        </label>
        <div class="col-md-6">
          <div *ngIf="!loadingLocations">
            <div *ngIf="locations.length > 0">
              <div *ngIf="!viewMode">
                <ng-select
                  [items]="locations"
                  [clearable]="false"
                  [closeOnSelect]="false"
                  [multiple]="true"
                  groupBy="parent"
                  bindLabel="name"
                  bindValue="id"
                  placeholder="{{ 'SELECT_LOCATION' | translate }}"
                  formControlName="location_ids"
                >
                  <ng-template ng-option-tmp let-item="item">
                    <div class="treelevel-{{ item.treelevel }}">
                      {{ item.name }}
                    </div>
                  </ng-template>
                </ng-select>

                <!-- <mat-select
                  formControlName="location_ids"
                  placeholder="{{ 'SELECT_LOCATION' | translate }}"
                  multiple
                >
                  <mat-option *ngFor="let location of locations" [value]="location.id">
                    <div class="treelevel-{{ location.treelevel }}">
                      {{ location.name }}
                    </div>
                  </mat-option>
                </mat-select> -->
                <app-form-errors
                  [control]="form.controls['location_ids']"
                  [formSubmited]="formSubmited"
                ></app-form-errors>
              </div>

              <div *ngIf="viewMode" class="form-label-transparent">
                <span *ngFor="let location of zone.locations">
                  <span class="label label-default label-md">{{ location.name }}</span
                  >&nbsp;
                </span>
              </div>
            </div>
            <!-- Empty locations -->
            <div *ngIf="locations.length === 0">
              <div class="label label-danger">{{ 'NO_LOCATIONS_SET' | translate }}</div>
              <a href class="btn btn-xs btn-success" (click)="openLocationsModal()">
                <i class="fa fa-plus"></i> {{ 'ADD_LOCATION' | translate }}
              </a>
            </div>
          </div>
          <div *ngIf="loadingLocations" class="form-label text-muted">
            {{ 'LOADING' | translate }}...
          </div>
        </div>
      </div>
    </div>
    <!-- /widget-content -->
  </div>
  <!-- /widget -->

  <div class="widget" *ngIf="!createMode">
    <div class="widget-header">
      <h4>{{ 'PICKUP_PLACES' | translate }}</h4>
      <div class="toolbar" *ngIf="!viewMode">
        <div class="btn-group">
          <span class="dropdown-toggle btn btn-xs" data-toggle="dropdown">
            <i class="fa fa-cog"></i>
          </span>
          <ul class="dropdown-menu pull-right">
            <li>
              <a href (click)="openPickupPlacesModal()">
                <i class="fa fa-truck fa-sized"></i> {{ 'EDIT_PICKUP_PLACES' | translate }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="widget-content">
      <!-- <div class="form-group"> -->
      <!-- <div class="col-md-6"> -->
      <div *ngIf="zone.pickup_places.length > 0">
        <table
          class="table table-striped table-bordered table-highlight-head table-responsive table-vertical-align"
        >
          <thead>
            <tr>
              <th>
                {{ 'NAME' | translate }}
              </th>
              <th>
                {{ 'TYPE' | translate }}
              </th>
              <th>
                {{ 'LOCATION' | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let pickup_place of zone.pickup_places">
              <td [ngClass]="utilService.checkItemStatus(pickup_place.status)">
                {{ pickup_place.name }}
              </td>
              <td [ngClass]="utilService.checkItemStatus(pickup_place.status)">
                {{ pickup_place.type | uppercase | translate }}
              </td>
              <td [ngClass]="utilService.checkItemStatus(pickup_place.status)">
                {{ pickup_place.location.name }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="form-label" *ngIf="zone.pickup_places.length == 0">
        <button type="button" class="btn btn-xs" (click)="openPickupPlacesModal()">
          <i class="fa fa-pencil"></i> {{ 'EDIT_PICKUP_PLACES' | translate }}
        </button>
      </div>
      <!-- </div> -->
      <!-- <div class="col-md-6">
          map ??
          <map
            id="map"
            class="map"
            lat=""
            lng=""
            zoom="9"
            option="multiple"
            items="zonePickUpPlaces"
            style="height: 400px"
          ></map> -->

      <!-- <div *ngIf="googleMapLoaded">
            <app-map
              [lat]="zone.geo_lat"
              [lng]="zone.geo_lng"
              [zoom]="zone.geo_zoom"
              [viewMode]="viewMode"
              (selectedMapPlace)="onSelectedMapPlace($event)"
            ></app-map>
          </div> -->
      <!-- </div> -->
      <!-- </div> -->
    </div>
    <!-- /widget-content -->
  </div>
  <!-- /widget -->

  <div class="form-actions no-wrap">
    <app-item-detail-form-actions
      [createMode]="createMode"
      [disableSaveItem]="form.invalid || (!loadingLocations && locations.length === 0)"
      [sendingForm]="sendingForm"
      [viewMode]="viewMode"
      (canceled)="onCanceled()"
      (edited)="onEditedZone()"
      (saved)="onSavedZone()"
    >
    </app-item-detail-form-actions>
  </div>
</form>
